export default __webpack_public_path__ + "static/media/Uriel_Hernandez.b004e572.png";